'use client';

import * as Sentry from '@sentry/nextjs';
import Error from 'next/error';
import { useEffect } from 'react';

// eslint-disable-next-line import/no-default-export
export default function GlobalError({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en-US">
      <body>
        <div className="flex h-screen w-full flex-col items-center justify-center">
          <h2 className="text-2xl font-bold">Something went wrong!</h2>
          <button
            className="mt-4 rounded-md bg-purple-500 px-4 py-2 text-white hover:bg-purple-700 border text-base font-semibold shadow-xs transition-all duration-200 border-gray-200 hover:shadow-sm"
            onClick={() => reset()}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
